<template>
    <div class="wrap">
        <div class="d-flex">
            <div class="mr-auto">
                <button class="btn btn-secondary" @click="refresh"><i class="fas fa-sync-alt"></i></button>
                <slot name="buttons"></slot>
            </div>
            <div class="align-self-end">
                <input-debounced
                        v-model="search"
                        :clearable="true"
                        :autofocus="true"
                        placeholder="Search"
                        class="search-bar w-300 mb-2"
                ></input-debounced>
            </div>
        </div>
        <base-table
                :base-url="urlWithFilters"
                ref="baseTable"
                @load-success="onLoadSuccess"
                @refresh="onRefresh"
                :current-page="currentPage"
                v-loading="isRefreshing"
                element-loading-spinner="el-icon-loading"
        >
            <template v-slot>
                <el-table
                        :data="items"
                        stripe
                        class="w-100"
                >
                    <el-table-column
                            prop="model.id"
                            label="Id"
                            min-width="80"
                    ></el-table-column>
                    <el-table-column
                            prop="model.title"
                            label="Title"
                            min-width="150"
                    ></el-table-column>
                    <el-table-column
                            prop="model.user.full_name"
                            label="User"
                            min-width="150"
                    ></el-table-column>
                    <el-table-column
                            prop="model.description"
                            label="Description"
                            min-width="150"
                    ></el-table-column>
                    <el-table-column
                            prop="model.created_at"
                            label="Created"
                            min-width="120"
                            :formatter="formatDate"
                    ></el-table-column>
                    <el-table-column
                            label="Actions"
                            v-slot="{row}"
                    >
                        <actions-column
                                :row="row"
                                :playing-id="playingId"
                                @play="playerPlay"
                                @stop="playerStop"
                                @edit="onEdit"
                                @delete="onDelete"
                        ></actions-column>
                    </el-table-column>
                </el-table>
            </template>
        </base-table>
        <el-pagination
                layout="prev, pager, next"
                :total="total"
                :current-page.sync="currentPage"
                :page-size="pageSize"
                class="text-right"
        ></el-pagination>
        <audio-player ref="player" @stop="onPlayerStop"></audio-player>
    </div>
</template>

<script>
  import TableWithPagination from '../table-with-pagination';
  import {addQueryParams} from '../../libs/url';
  import ActionsColumn from './actions-column';
  import SharedColumn from './shared-column';
  import AudioPlayer from './audio-player';
  import eventBus from '../../event-bus';

  export default {
    extends: TableWithPagination,

    components: {
      ActionsColumn,
      SharedColumn,
      AudioPlayer,
    },

    data() {
      return {
        search: null,
        filters: {},
        playingId: null,
      };
    },

    computed: {
      /**
       * @return {string}
       */
      urlWithFilters() {
        return addQueryParams(this.url, this.filters);
      },

      /**
       * @return {boolean}
       */
      isPlayingAudio() {
        return Boolean(this.playingId);
      },
    },

    watch: {
      search: function (value) {
        this.filters = value
          ? _.assign({}, this.filters, {search: value})
          : this.filters = _.omit(this.filters, ['search']);
      },
    },

    methods: {
      /**
       * @param {object} row
       * @param {object} col
       * @param {string} datetime
       * @return {string}
       */
      formatDate(row, col, {datetime}) {
        return moment(datetime).format(config('format.moment.short.datetime'));
      },

      /**
       * @param {object} payload
       */
      playerPlay({id, url}) {
        this.$refs.player.play(url)
          .then(() => {
            this.playingId = id;
          })
          .catch(() => {
            this.playingId = null;
            this.$message.error('Playback error');
          });
      },

      /**
       * @return {undefined}
       */
      playerStop() {
        this.$refs.player.stop();
      },

      /**
       * @return {undefined}
       */
      onPlayerStop() {
        this.playingId = null;
      },

      /**
       * @return {undefined}
       */
      refresh() {
        this.isPlayingAudio && this.playerStop();
        this.$refs.baseTable.refresh();
      },

      /**
       * @param {string} url
       * @event show-add-audio-dialog
       */
      onEdit({url}) {
        eventBus.$emit('show-add-audio-dialog', url);
      },

      /**
       * @param {string} url
       */
      onDelete({url}) {
        axios.post(url, {_method: 'DELETE'})
          .then(({data: {message}}) => {
            _.isString(message) && this.$message.success(message);
            this.refresh();
          })
          .catch((err) => {
            const message = _.get(err, 'response.data.message');
            _.isString(message) && this.$message.error(message);
          });
      }
    }
  }
</script>
